module.exports = __webpack_public_path__ + "static/media/de_logo.74a50029.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/de_logo.png
// module id = 515
// module chunks = 50